module.exports = __webpack_public_path__ + "img/rosman-market-new.efcbba4b.png";